module.exports = __webpack_public_path__ + "static/img/1_1_1_1.2fe69ef6.jpg";